import { render } from "./footerLogoImg.vue?vue&type=template&id=28ef44e3"
import script from "./footerLogoImg.vue?vue&type=script&lang=js"
export * from "./footerLogoImg.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src719114813/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__